<template>
  <div class="fill-height">

    <div v-if="!isAppOnline" class="fill-height">
      <v-layout column align-center fill-height justify-center>
        <NoConnection :size="72"/>
        Sem conexão com a internet.
      </v-layout>
    </div>

    <slot v-else/>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import NoConnection from '@/components/icons/NoConnection'

export default {
  name: 'only-online',

  components: {
    NoConnection
  },

  computed: {
    ...mapState({
      isAppOnline: state => state.network.online
    })
  }
}
</script>

<style lang="stylus" scoped>
  .fill-height
    height 100%
</style>
